import { api as generatedApi } from 'gen/rtk-openapi'

const TAG_TYPES = {
  user: 'User',
}

export const api = generatedApi.enhanceEndpoints({
  addTagTypes: [TAG_TYPES.user],
  endpoints: {
    getGsUserList: {
      providesTags: result =>
        result?.Items
          ? [...result.Items.map(({ id }) => ({ type: TAG_TYPES.user, id })), { type: TAG_TYPES.user, id: 'LIST' }]
          : [{ type: TAG_TYPES.user, id: 'LIST' }],
    },
    getGsUser: {
      providesTags: (_result, _error, { userId }) => [{ type: TAG_TYPES.user, id: userId }],
    },
    createGsUser: {
      invalidatesTags: [{ type: TAG_TYPES.user, id: 'LIST' }],
    },
    updateGsUser: {
      invalidatesTags: (_result, _error, { userId }) => [
        { type: TAG_TYPES.user, id: userId },
        { type: TAG_TYPES.user, id: 'LIST' },
      ],
    },
    resetGsUserPassword: {
      // no cache tags needed
    },
  },
})

export const {
  useGetGsUserListQuery,
  useGetGsUserQuery,
  useCreateGsUserMutation,
  useUpdateGsUserMutation,
  useResetGsUserPasswordMutation,
} = api
